import Icon from '@mdi/react';
import { Dialog, DialogContent, DialogTrigger } from '@purinanbm/pds-ui';
import React from 'react';
import { mdiClose } from 'src/assets/icons/mdiIcons';
import { IInnerProps } from '../types';
import { HotspotContent } from './HotspotContent';
import { HotspotTrigger } from './HotspotTrigger';

export const HotspotDialog: React.FC<IInnerProps> = ({ point, markerContent, markerMedia }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const { name } = markerContent;

  return (
    <Dialog open={isOpen} onOpenChange={open => setIsOpen(open)}>
      <DialogTrigger asChild key={markerContent.name}>
        <HotspotTrigger
          name={name}
          markerMedia={markerMedia}
          style={{
            left: `${point.x}%`,
            top: `${point.y}%`,
          }}
        />
      </DialogTrigger>
      <DialogContent className="pds-p-0" forceMount>
        <div className="pds-p-4">
          <button
            className="pds-absolute pds-right-4.5 pds-top-4.5 pds-z-oneBelowTop pds-rounded-circle pds-bg-surface pds-p-2"
            type="button"
            onClick={() => setIsOpen(false)}
          >
            <Icon
              className="pds-block"
              // @ts-ignore - width
              width={32}
              path={mdiClose}
            />
            <div className="pds-sr-only">Close</div>
          </button>
          <HotspotContent hotspot={markerContent} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
